import * as services from 'services/mail';
import get from 'lodash/get';
import * as gmailServices from '../../services/gmail';

export const SET_ERROR = 'projects/SET_ERROR';
export const CLEAR_ERROR = 'projects/CLEAR_ERROR';
export const REQUEST_STARTED = 'projects/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'projects/REQUEST_SUCCESSFUL';
export const SET_EMAILS = 'emails/SET_EMAILS';
export const EDIT_EMAIL = 'emails/EDIT_EMAIL';
export const GET_EMAILS_FROM_SERVER = 'emails/GET_EMAILS_FROM_SERVER';
export const DELETE_EMAIL = 'emails/DELETE_EMAIL';
export const ADD_EMAIL = 'emails/ADD_EMAIL';
export const SENDING_FAILED = 'emails/SENDING_FAILED';
export const ADD_SENT_EMAIL = 'emails/ADD_SENT_EMAIL';
export const ADD_TO_QUEUE = 'emails/ADD_TO_QUEUE';
export const FINISHED_QUEUE = 'email/FINISHED_QUEUE';
export const SET_GMAIL_ACCOUNTS = 'emails/SET_GMAIL_ACCOUNTS';
export const SET_EMAIL_TYPES = 'emails/SET_EMAIL_TYPES';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setEmails = emails => ({
  type: SET_EMAILS,
  emails,
});

export const addSentEmail = emailId => ({
  type: ADD_SENT_EMAIL,
  emailId,
});

export const finishedQueue = () => ({
  type: FINISHED_QUEUE,
});

export const setGmailAccounts = gmailAccounts => ({
  type: SET_GMAIL_ACCOUNTS,
  gmailAccounts,
});

export const setEmailTypes = emailTypes => ({
  type: SET_EMAIL_TYPES,
  emailTypes,
});

export const getEmailTypesFromServer = () => dispatch => {
  dispatch(requestStarted());
  services
    .getEmailTypes()
    .then(emailTypes => {
      dispatch(setEmailTypes(emailTypes));
      dispatch(requestCompleted());
    })
    .catch(err => {
      dispatch(setEmailTypes([]));
      if (!err.message.includes('code 403')) {
        dispatch(setError('Error fetching email types'));
      }
      dispatch(requestCompleted());
    });
};

const sendEmail = (id, emailData) => dispatch => {
  services
    .sendSavedTemplate(emailData)
    .then(() => {
      dispatch(addSentEmail(id));
      dispatch(requestCompleted());
    })
    .catch(e => {
      const errMsg = e.response?.data?.error?.message;
      dispatch(setError(errMsg || 'Unable to send emails'));
      dispatch(requestCompleted());
    });
};

const sendMultiTemplateEmail = (id, emailData) => dispatch => {
  services
    .sendMultiTemplate(emailData)
    .then(() => {
      dispatch(addSentEmail(id));
      dispatch(requestCompleted());
    })
    .catch(e => {
      const errMsg = e.response?.data?.error?.message;
      dispatch(setError(errMsg || 'Unable to send emails'));
      dispatch(requestCompleted());
    });
};

const scheduleEmailSend = (id, emailData) => dispatch => {
  services
    .scheduleMailSavedTemplate(emailData)
    .then(() => {
      dispatch(addSentEmail(id));
      dispatch(requestCompleted());
    })
    .catch(err => {
      const errorMessage = get(
        err,
        'response.data.error.message',
        'Unable to send emails',
      );
      dispatch(setError(errorMessage));
      dispatch(requestCompleted());
    });
};

export const sendSavedTemplate = (id, emailData) => dispatch => {
  dispatch(requestStarted());
  dispatch(sendEmail(id, emailData));
};

export const sendMultiTemplate = (id, emailData) => dispatch => {
  dispatch(requestStarted());
  dispatch(sendMultiTemplateEmail(id, emailData));
};

export const scheduleMailSavedTemplate = (id, emailData) => dispatch => {
  dispatch(requestStarted());
  dispatch(scheduleEmailSend(id, emailData));
};

export const fetchGmailAccounts = () => dispatch => {
  dispatch(requestStarted());
  gmailServices
    .getAuthorizedGmailAccounts()
    .then(gmailAccounts => {
      dispatch(setGmailAccounts(gmailAccounts));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(requestCompleted());
    });
};
